// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drawflow,
.drawflow .parent-node {
  position: relative;
}

.parent-drawflow {
  display: flex;
  overflow: hidden;
  touch-action: none;
  outline: 0;
}

.drawflow {
  width: 100%;
  height: 100%;
  -webkit-user-select: none;
          user-select: none;
}

.drawflow .drawflow-node {
  display: flex;
  align-items: center;
  position: absolute;
  background: #0ff;
  width: 160px;
  min-height: 40px;
  border-radius: 4px;
  border: 2px solid #000;
  color: #000;
  z-index: 2;
  padding: 15px;
}

.drawflow .drawflow-node.selected {
  background: red;
}

.drawflow .drawflow-node:hover {
  cursor: move;
}

.drawflow .drawflow-node .inputs,
.drawflow .drawflow-node .outputs {
  width: 0;
}

.drawflow .drawflow-node .drawflow_content_node {
  width: 100%;
  display: block;
}

.drawflow .drawflow-node .input,
.drawflow .drawflow-node .output {
  position: relative;
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 50%;
  border: 2px solid #000;
  cursor: crosshair;
  z-index: 1;
  margin-bottom: 5px;
}

.drawflow .drawflow-node .input {
  left: -27px;
  top: 2px;
  background: #ff0;
}

.drawflow .drawflow-node .output {
  right: -3px;
  top: 2px;
}

.drawflow svg {
  z-index: 0;
  position: absolute;
  overflow: visible !important;
}

.drawflow .connection {
  position: absolute;
  transform: translate(9999px, 9999px);
  height: 200px;
  padding-left: 6px;
}

@media (min-width: 1200px) and (max-width: 1300px) {
  .drawflow .connection {
    padding-left: 4px;
  }
}
@media (min-width: 1301px) and (max-width: 1400px) {
  .drawflow .connection {
    padding-left: 4px;
  }
}
@media (min-width: 1401px) and (max-width: 1600px) {
  .drawflow .connection {
    padding-left: 4px;
  }
}
@media (min-width: 1601px) and (max-width: 1800px) {
  .drawflow .connection {
    padding-left: 4px;
  }
}
@media (min-width: 1801px) and (max-width: 1920px) {
  .drawflow .connection {
    padding-left: 4px;
  }
}
@media (min-width: 1921px) and (max-width: 2200px) {
  .drawflow .connection {
    padding-left: 12px;
  }
}
.drawflow .connection .main-path {
  fill: none;
  stroke-width: 5px;
  stroke: #4682b4;
  transform: translate(-9999px, -9999px);
}

.drawflow .connection .main-path:hover {
  stroke: #1266ab;
  cursor: pointer;
}

.drawflow .connection .main-path.selected {
  stroke: #43b993;
}

.drawflow .connection .point {
  cursor: move;
  stroke: #000;
  stroke-width: 2;
  fill: #fff;
  transform: translate(-9999px, -9999px);
}

.drawflow .connection .point.selected,
.drawflow .connection .point:hover {
  fill: #1266ab;
}

.drawflow .main-path {
  fill: none;
  stroke-width: 5px;
  stroke: #4682b4;
}

.drawflow .selectbox {
  z-index: 3;
  position: absolute;
  transform: translate(9999px, 9999px);
}

.drawflow .selectbox rect {
  fill: #00f;
  opacity: 0.5;
  stroke: #ff0;
  stroke-width: 5;
  stroke-opacity: 0.5;
  transform: translate(-9999px, -9999px);
}

.drawflow-delete {
  position: absolute;
  display: block;
  width: 30px;
  height: 30px;
  background: #000;
  color: #fff;
  z-index: 4;
  border: 2px solid #fff;
  line-height: 30px;
  font-weight: 700;
  text-align: center;
  border-radius: 50%;
  font-family: monospace;
  cursor: pointer;
}

.drawflow > .drawflow-delete {
  margin-left: -15px;
  margin-top: 15px;
}

.parent-node .drawflow-delete {
  right: -15px;
  top: -15px;
}

:root {
  --border-color: #cacaca;
  --background-color: #ffffff;
  --background-box-title: #f7f7f7;
}

html,
body {
  margin: 0px;
  padding: 0px;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-family: "Lato", sans-serif;
}

header {
  height: 66px;
  border-bottom: 1px solid var(--border-color);
  padding-left: 20px;
}

header h2 {
  margin: 0px;
  line-height: 66px;
}

header a {
  color: black;
}

.them-edit-link {
  position: absolute;
  top: 10px;
  right: 100px;
  color: black;
  font-size: 40px;
}

.them-edit-link a {
  text-decoration: none;
}

.github-link {
  position: absolute;
  top: 10px;
  right: 20px;
  color: black;
}

.wrapper {
  width: 100%;
  height: calc(100vh - 67px);
  display: flex;
}

.col {
  overflow: auto;
  width: 300px;
  height: 100%;
  border-right: 1px solid var(--border-color);
}

.drag-drawflow {
  line-height: 50px;
  border-bottom: 1px solid var(--border-color);
  padding-left: 5px;
  cursor: move;
  -webkit-user-select: none;
          user-select: none;
}

.menu {
  position: absolute;
  height: 40px;
  display: block;
  background: white;
  width: 100%;
}

.menu ul {
  padding: 0px;
  margin: 0px;
  line-height: 40px;
}

.menu ul li {
  display: inline-block;
  margin-left: 10px;
  border-right: 1px solid var(--border-color);
  padding-right: 10px;
  line-height: 40px;
  cursor: pointer;
}

.menu ul li.selected {
  font-weight: bold;
}

.swal-wide {
  width: 80% !important;
}

.bar-zoom svg {
  cursor: pointer;
  padding-left: 10px;
}

.bar-zoom svg:nth-child(1) {
  padding-left: 0px;
}

#drawflow {
  position: relative;
  width: calc(100vw - 40px);
  height: calc(100% - 80px);
  background: var(--background-color);
  background-size: 25px 25px;
  background-image: linear-gradient(to right, #f1f1f1 1px, transparent 1px), linear-gradient(to bottom, #f1f1f1 1px, transparent 1px);
}

@media only screen and (max-width: 768px) {
  .col {
    width: 50px;
  }
  .col .drag-drawflow span {
    display: none;
  }
  #drawflow {
    width: calc(100vw - 51px);
  }
}
/* Editing Drawflow */
.drawflow .drawflow-node {
  background: var(--background-color);
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 15px 2px var(--border-color);
  padding: 0px;
  width: 200px;
}

.drawflow .drawflow-node.selected {
  background: white;
  border: 1px solid #4ea9ff;
  box-shadow: 0 2px 20px 2px #4ea9ff;
}

.drawflow .drawflow-node.selected .auto-cx-node {
  color: #22598c;
}

.drawflow .connection .main-path {
  stroke: #4ea9ff;
  stroke-width: 3px;
}

.drawflow .drawflow-node .input,
.drawflow .drawflow-node .output {
  height: 15px;
  width: 15px;
  border: 2px solid var(--border-color);
}

.drawflow .drawflow-node .input:hover,
.drawflow .drawflow-node .output:hover {
  background: #4ea9ff;
}

.drawflow .drawflow-node .output {
  right: 10px;
}

.drawflow .drawflow-node .input {
  left: -10px;
  background: white;
}

.drawflow > .drawflow-delete {
  border: 2px solid #43b993;
  background: white;
  color: #43b993;
  box-shadow: 0 2px 20px 2px #43b993;
}

.drawflow-delete {
  border: 2px solid #4ea9ff;
  background: white;
  color: #4ea9ff;
  box-shadow: 0 2px 20px 2px #4ea9ff;
}

.drawflow-node .auto-cx-node {
  height: 50px;
  line-height: 50px;
  background: var(--background-box-title);
  border-bottom: 1px solid #e9e9e9;
  border-radius: 4px 4px 0px 0px;
  padding-left: 10px;
}
.drawflow-node .auto-cx-node input {
  background: transparent;
  border: none;
  font-family: Lato;
}

.drawflow .auto-cx-node svg {
  position: initial;
}

.drawflow-node .box {
  padding: 10px 20px 20px 20px;
  font-size: 14px;
  color: #555555;
}

.drawflow-node .box p {
  margin-top: 5px;
  margin-bottom: 5px;
}

.drawflow-node.welcome {
  width: 250px;
}

.drawflow-node.slack .auto-cx-node {
  border-radius: 4px;
}

.drawflow-node.primitive .auto-cx-node {
  border-radius: 4px;
}

.drawflow-node.composite .auto-cx-node {
  border-radius: 4px;
}

.drawflow-node.operator .auto-cx-node {
  border-radius: 4px;
}

.drawflow-node.logic .auto-cx-node {
  border-radius: 4px;
}

.drawflow-node input,
.drawflow-node select,
.drawflow-node textarea {
  border-radius: 4px;
  border: 1px solid var(--border-color);
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  width: 158px;
  color: #555555;
}

.drawflow-node textarea {
  height: 100px;
}

.drawflow-node.personalized {
  background: red;
  height: 200px;
  text-align: center;
  color: white;
}

.drawflow-node.personalized .input {
  background: yellow;
}

.drawflow-node.personalized .output {
  background: green;
}

.drawflow-node.personalized.selected {
  background: blue;
}

.drawflow .connection .point {
  stroke: var(--border-color);
  stroke-width: 2;
  fill: white;
  transform: translate(-9999px, -9999px);
}

.drawflow .connection .point.selected,
.drawflow .connection .point:hover {
  fill: #4ea9ff;
}

/* Modal */
.modal {
  display: none;
  position: fixed;
  z-index: 7;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.7);
}

.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: 15% auto;
  /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  /* Could be more or less, depending on screen size */
}

/* The Close Button */
.modal .close {
  color: #aaa;
  float: right;
  font-family: Lato;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

@media only screen and (max-width: 768px) {
  .modal-content {
    width: 80%;
  }
}
:host .custom-dialog-container .mat-mdc-dialog-container {
  position: absolute;
  height: 80%;
  width: 80%;
  padding: 0px !important;
}

.wrapper-view {
  width: 100% !important;
  height: calc(100vh - 100px) !important;
  display: flex !important;
}

.view-width {
  width: calc(100vw - 35%) !important;
}

.workspace {
  width: 100%;
  padding-left: 0px;
}

.workspace-background {
  background-color: #fafafa !important;
}

.drawer-container {
  margin: 0;
  border-radius: 0;
  width: 100% !important;
  height: 100%;
  position: relative;
}

mat-drawer {
  overflow: hidden;
  height: 100%;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15) !important;
  width: 20% !important;
  display: flex;
  flex-direction: column;
  position: relative;
}

mat-drawer-content {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  overflow: hidden;
  width: 100%;
  background-color: none !important;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.drawer-toggle-tab {
  position: absolute;
  left: 0;
  top: 9%;
  transform: translateY(-50%);
  height: 120px;
  width: 48px;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--primary);
  color: white;
  border: 2px solid var(--primary);
  border-left: none;
  border-radius: 0 20px 20px 0;
  cursor: pointer;
  transition: left 400ms cubic-bezier(0.25, 0.8, 0.25, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 12px 2px 16px rgba(0, 0, 0, 0.2);
  z-index: 99;
}
.drawer-toggle-tab .tab-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.drawer-toggle-tab .tab-label {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: white;
  -webkit-user-select: none;
          user-select: none;
}
.drawer-toggle-tab:hover {
  width: 56px;
  box-shadow: 12px 2px 16px rgba(0, 0, 0, 0.2);
  border-color: var(--primary);
}
.drawer-toggle-tab:hover .tab-icon {
  transform: translateX(3px) scale(1.1);
}
.drawer-toggle-tab:active {
  transform: translateY(-50%) scale(0.97);
}
.drawer-toggle-tab.drawer-open {
  left: 20%;
}
.drawer-toggle-tab.drawer-open .tab-icon {
  transform: rotate(180deg);
}
.drawer-toggle-tab.drawer-open:hover {
  width: 56px;
}
.drawer-toggle-tab.drawer-open:hover .tab-icon {
  transform: rotate(180deg) translateX(3px) scale(1.1);
}

.flow-header {
  margin: 0px;
  padding: 0px;
  background: white;
  border-bottom: 1px solid #f0f0f0;
  min-height: 60px;
}

.library-header {
  background: linear-gradient(to bottom, #fafafa, #f5f5f5);
  height: 48px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
  position: relative;
}

.flow-library-label {
  font-size: 14px;
  color: #333;
  height: 48px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.view-header {
  height: auto !important;
  border-radius: 0;
  display: flex;
  flex-wrap: nowrap;
  padding: 12px 16px 12px 64px;
  background: white;
  border-bottom: 1px solid #f0f0f0;
}
.view-header .col-4, .view-header .col-5 {
  display: flex;
  align-items: center;
  font-size: 13px;
  min-width: 0;
}

.blocks-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 8px;
  padding: 12px 0;
  width: 100% !important;
  flex: 1 !important;
  min-width: 0;
}

.expansion-header {
  padding: 0 16px !important;
}

.text-input,
.select-input {
  font-size: 13px;
  margin-top: 8px;
  padding-left: 8px;
  color: #424242;
  transition: border-color 0.2s ease;
}
.text-input:focus,
.select-input:focus {
  outline: none;
  border-color: var(--primary) !important;
}

.text-input {
  font-size: 13px !important;
  margin-top: 8px !important;
  padding-left: 8px !important;
  height: 32px;
  color: #424242 !important;
  z-index: 1 !important;
  background: white !important;
  border: none !important;
}

.mat-mdc-form-field.custom-edit-field {
  font-size: 0.8rem;
  padding: 10px;
}
.mat-mdc-form-field.custom-edit-field .mat-mdc-form-field-wrapper {
  padding-bottom: 1.25em;
}
.mat-mdc-form-field.custom-edit-field input.mat-mdc-input-element {
  padding: 2px 0px;
}
.mat-mdc-form-field.custom-edit-field .mat-mdc-form-field-infix {
  padding: 2px 0px;
  border-top: 0em solid transparent;
}
.mat-mdc-form-field.custom-edit-field .mat-mdc-form-field-label-wrapper {
  top: 3px;
  padding-top: 0;
}
.mat-mdc-form-field.custom-edit-field .mat-mdc-form-field-label {
  top: 0em;
}
.mat-mdc-form-field.custom-edit-field .mat-mdc-form-field-subscript-wrapper {
  margin-top: 3px;
}

.form-table {
  margin-bottom: 16px;
  width: 100%;
  transition: margin-left 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
}
.form-table.drawer-open {
  margin-left: 20%;
  width: 80% !important;
}
.form-table.drawer-open td {
  white-space: nowrap;
}
.form-table.drawer-open td:first-child {
  padding-left: 70px !important;
}
.form-table tr {
  line-height: 20px;
  background-color: #ffffff !important;
}

table td {
  color: #666 !important;
  word-wrap: break-word;
  font-size: 12px;
  vertical-align: middle;
}

.flow-management-form {
  padding-left: 10px;
}
.flow-management-form .btn-form {
  color: var(--primary);
  background: #ffffff;
  border-radius: 6px;
  cursor: pointer;
  z-index: 5;
  margin-left: 10px;
  transition: all 0.2s ease;
}
.flow-management-form .btn-form:hover {
  background: #f5f5f5;
}

.flow-search {
  box-shadow: none;
  border-bottom: 1px solid rgba(169, 169, 169, 0.3);
  padding: 8px 12px;
  background: #fafafa;
  position: sticky;
  top: 0;
  z-index: 10;
  flex-shrink: 0;
  height: 36px;
}
.flow-search input {
  border: none;
  background: transparent;
  width: 100%;
  font-size: 13px;
}
.flow-search input::placeholder {
  color: #999;
}

.flow-selection-area {
  max-height: none;
  overflow: visible;
}

.block-search {
  padding: 0 12px;
  margin: 12px 0;
}
.block-search ::ng-deep .mat-mdc-input-element {
  font-size: 13px;
}
.block-search ::ng-deep .mat-mdc-form-field {
  width: 100%;
}

.flow-ui-wrapper {
  margin-left: -1rem;
  width: calc(100% + 1rem);
}
.flow-ui-wrapper .drag-drawflow {
  line-height: 24px;
}
.flow-ui-wrapper .drawflow {
  position: absolute !important;
}
.flow-ui-wrapper .element-tile {
  font-weight: 400;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin: 4px;
  padding: 4px 6px;
  font-size: 14px;
  line-height: 24px;
  background: white;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: grab;
  position: relative;
}
.flow-ui-wrapper .element-tile:hover {
  border-color: var(--primary);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}
.flow-ui-wrapper .element-tile:active {
  cursor: grabbing;
}
.flow-ui-wrapper .element-tile > span:first-child {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  z-index: 1;
}
.flow-ui-wrapper .element-tile > span:first-child i {
  font-size: 16px;
}
.flow-ui-wrapper .element-tile > span:nth-child(2) {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 0;
}
.flow-ui-wrapper .element-tile .element-options {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 8px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  background: linear-gradient(to right, transparent, white 20%, white);
  border-radius: 10px;
  pointer-events: none;
  z-index: 2;
}
.flow-ui-wrapper .element-tile .element-options button {
  border: none;
  background-color: white;
  color: #666;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
  font-size: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.flow-ui-wrapper .element-tile .element-options button:hover {
  color: var(--primary);
  background: #f0f0ff;
  transform: scale(1.1);
}
.flow-ui-wrapper .element-tile .element-options button.isShared {
  color: var(--primary);
}
.flow-ui-wrapper .element-tile:hover .element-options {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.auto-cx-node {
  display: flex;
  align-items: center;
  max-width: 300px;
  padding: 2px 4px;
  gap: 6px;
}
.auto-cx-node i {
  flex-shrink: 0;
  font-size: 16px;
}

.block-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1;
  font-size: 13px;
}

.blocks-display {
  display: block;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 4px;
  max-height: 48vh;
}
.blocks-display::-webkit-scrollbar {
  width: 6px;
}
.blocks-display::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.blocks-display::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.blocks-display::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.expanded-blocks {
  display: block;
  position: relative;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
.expanded-blocks::-webkit-scrollbar {
  width: 6px;
}
.expanded-blocks::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.expanded-blocks::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.expanded-blocks::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.default-blocks {
  padding: 8px 4px;
}

.mat-expansion-panel-body {
  padding: 0 !important;
}

.block-control {
  padding: 8px 12px;
  font-weight: 600;
  font-size: 12px;
  color: #444;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #f8f8f8;
  margin: 4px 8px 8px 8px;
  border-radius: 4px;
}

.flow-option {
  font-size: 13px;
  line-height: 1em;
  height: auto !important;
  padding: 8px 12px;
  display: block;
  transition: background 0.2s ease;
}
.flow-option:hover {
  background: #f5f5f5;
}

.flow-type {
  font-size: 11px;
  font-weight: 600;
  padding: 8px 12px;
  height: auto;
  display: block;
  color: var(--primary);
  background: #f8f8f8;
  margin: 4px 0;
}

.flow-auto-description {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 9999;
  background: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 12px 16px;
  color: #666;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-size: 13px;
}
.flow-auto-description label {
  font-weight: 600;
  color: #444;
  margin-right: 8px;
}
.flow-auto-description .flow-error {
  display: flex !important;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 8px 0 0 0;
  color: var(--warning);
  font-size: 12px;
}
.flow-auto-description .flow-error mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.btn-header-icon {
  color: var(--primary) !important;
  box-shadow: none !important;
  background: transparent !important;
  background-color: transparent;
  border: 1px solid transparent;
  margin: 0;
  min-width: auto;
  padding: 6px;
  transform: translateY(10px) !important;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.btn-header-icon:hover {
  background: #f5f5f5 !important;
}
.btn-header-icon mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.btn-navigate {
  color: var(--primary);
  background: white;
  border: 1px solid var(--primary) !important;
  border-radius: 6px !important;
  cursor: pointer;
  text-transform: uppercase;
  float: right;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}
.btn-navigate:hover {
  background: rgba(var(--primary-rgb), 0.05);
}

.btn-workspace {
  color: var(--primary) !important;
}

.add-custom {
  color: var(--primary);
  font-size: 10px;
  font-weight: 600;
  border: 1px solid var(--primary) !important;
  padding: 0 8px !important;
  margin-right: 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
  --mdc-text-button-container-shape: 6px !important;
  --mdc-text-button-container-height: 22px !important;
  height: 22px !important;
  white-space: nowrap;
  flex: 0 0 auto;
}
.add-custom:hover {
  background: rgba(var(--primary-rgb), 0.05);
}

.float-toggle {
  position: relative !important;
  bottom: 10px;
  right: 0;
  top: 25px;
  height: 37px;
  font-weight: 600;
  font-size: 12px;
  color: var(--primary);
  border: 1px solid var(--primary) !important;
  z-index: 5;
}

.tool-btn {
  position: absolute;
  z-index: 10;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.tool-btn:hover {
  background: #f5f5f5;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.tool-btn em {
  color: var(--primary);
  font-size: 18px;
  display: block;
}

.flow-toolbox {
  position: absolute;
  right: 16px;
  top: 60px;
}

.btn-delete {
  top: 0;
  right: 0;
}

.btn-publish {
  top: 56px;
  right: 0;
}

.btn-clear {
  top: 112px;
  right: 0;
}

.btn-lock {
  top: 168px;
  right: 0;
}

.bar-zoom {
  top: 224px;
  right: 0;
}

.bar-in {
  top: 280px;
  right: 0;
}

.bar-out {
  top: 336px;
  right: 0;
}

.control-label {
  font-size: 14px;
  color: #666;
  margin-top: 12px;
  font-weight: 500;
}

.element-type {
  font-weight: 600;
  font-size: 13px;
  color: #444;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  min-width: 0;
  flex: 0 1 auto;
  flex-shrink: 1;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.view-label {
  padding-right: 8px;
  font-weight: 600;
  color: #666;
  white-space: nowrap;
  flex-shrink: 0;
}

.view-header-label {
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.description-label {
  margin-top: 10px;
  height: 20px;
  line-height: 20px;
  display: flex;
  color: #666;
}

.truncate-label {
  max-width: 70% !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 2px;
  color: var(--text);
}

.alert {
  height: auto;
  color: var(--warning);
  font-size: 12px;
  padding: 4px 0;
}

.border-bottom {
  border-bottom: solid 1px #e0e0e0 !important;
}

.panel-elevation {
  margin: 8px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  border-radius: 8px !important;
  overflow: hidden;
}

.viewMode-position {
  top: 16px !important;
  right: 16px !important;
}

.no-result {
  padding: 16px;
  color: #999;
  text-align: center;
  font-size: 13px;
}

.no-blocks-found {
  padding: 20px;
  color: #999;
  text-align: center;
  font-size: 13px;
}

.empty-grid {
  padding: 40px 20px;
  text-align: center;
  color: #999;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/drawflow.scss","webpack://./src/app/auto-cx/components/auto-cx-builder/auto-cx-builder.component.scss","webpack://./src/assets/css/beautiful.scss"],"names":[],"mappings":"AAAA;;EAEI,kBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;ACCJ;;ADEA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;ACCJ;;ADEA;EACI,eAAA;ACCJ;;ADEA;EACI,YAAA;ACCJ;;ADEA;;EAEI,QAAA;ACCJ;;ADEA;EACI,WAAA;EACA,cAAA;ACCJ;;ADEA;;EAEI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,WAAA;EACA,QAAA;EACA,gBAAA;ACCJ;;ADEA;EACI,WAAA;EACA,QAAA;ACCJ;;ADEA;EACI,UAAA;EACA,kBAAA;EACA,4BAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,iBAAA;ACCJ;;ADEA;EACI;IACI,iBAAA;ECCN;AACF;ADEE;EACE;IACI,iBAAA;ECAN;AACF;ADGE;EACE;IACI,iBAAA;ECDN;AACF;ADIE;EACE;IACI,iBAAA;ECFN;AACF;ADKE;EACE;IACI,iBAAA;ECHN;AACF;ADME;EACE;IACI,kBAAA;ECJN;AACF;ADOA;EACI,UAAA;EACA,iBAAA;EACA,eAAA;EACA,sCAAA;ACLJ;;ADQA;EACI,eAAA;EACA,eAAA;ACLJ;;ADQA;EACI,eAAA;ACLJ;;ADQA;EACI,YAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,sCAAA;ACLJ;;ADQA;;EAEI,aAAA;ACLJ;;ADQA;EACI,UAAA;EACA,iBAAA;EACA,eAAA;ACLJ;;ADQA;EACI,UAAA;EACA,kBAAA;EACA,oCAAA;ACLJ;;ADQA;EACI,UAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,sCAAA;ACLJ;;ADQA;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;ACLJ;;ADQA;EACI,kBAAA;EACA,gBAAA;ACLJ;;ADQA;EACI,YAAA;EACA,UAAA;ACLJ;;AChMA;EACE,uBAAA;EACA,2BAAA;EAEA,+BAAA;ADkMF;;AC/LA;;EAEE,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,+BAAA;ADkMF;;AC/LA;EACE,YAAA;EACA,4CAAA;EACA,kBAAA;ADkMF;;AC/LA;EACE,WAAA;EACA,iBAAA;ADkMF;;AC/LA;EACE,YAAA;ADkMF;;AC/LA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;ADkMF;;AC/LA;EACE,qBAAA;ADkMF;;AC/LA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;ADkMF;;AC/LA;EACE,WAAA;EACA,0BAAA;EACA,aAAA;ADkMF;;AC/LA;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,2CAAA;ADkMF;;AC/LA;EACE,iBAAA;EACA,4CAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;ADkMF;;AC/LA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;ADkMF;;AC/LA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;ADkMF;;AC/LA;EACE,qBAAA;EACA,iBAAA;EACA,2CAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;ADkMF;;AC/LA;EACE,iBAAA;ADkMF;;AC/LA;EACE,qBAAA;ADkMF;;AC/LA;EACE,eAAA;EACA,kBAAA;ADkMF;;AC/LA;EACE,iBAAA;ADkMF;;AC/LA;EACE,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mCAAA;EACA,0BAAA;EACA,mIACE;ADiMJ;;AC7LA;EACE;IACE,WAAA;EDgMF;EC7LA;IACE,aAAA;ED+LF;EC5LA;IACE,yBAAA;ED8LF;AACF;AC3LA,qBAAA;AAEA;EACE,mCAAA;EACA,qCAAA;EAEA,8CAAA;EACA,YAAA;EACA,YAAA;AD4LF;;ACzLA;EACE,iBAAA;EACA,yBAAA;EAEA,kCAAA;AD4LF;;ACzLA;EACE,cAAA;AD4LF;;ACzLA;EACE,eAAA;EACA,iBAAA;AD4LF;;ACzLA;;EAEE,YAAA;EACA,WAAA;EACA,qCAAA;AD4LF;;ACzLA;;EAEE,mBAAA;AD4LF;;ACzLA;EACE,WAAA;AD4LF;;ACzLA;EACE,WAAA;EACA,iBAAA;AD4LF;;ACzLA;EACE,yBAAA;EACA,iBAAA;EACA,cAAA;EAEA,kCAAA;AD4LF;;ACzLA;EACE,yBAAA;EACA,iBAAA;EACA,cAAA;EAEA,kCAAA;AD4LF;;ACzLA;EAOE,YAAA;EACA,iBAAA;EACA,uCAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;ADsLF;ACjME;EACE,uBAAA;EACA,YAAA;EACA,iBAAA;ADmMJ;;ACxLA;EACE,iBAAA;AD2LF;;ACxLA;EACE,4BAAA;EACA,eAAA;EACA,cAAA;AD2LF;;ACvLA;EACE,eAAA;EACA,kBAAA;AD0LF;;ACvLA;EACE,YAAA;AD0LF;;ACvLA;EACE,kBAAA;AD0LF;;ACvLA;EACE,kBAAA;AD0LF;;ACvLA;EACE,kBAAA;AD0LF;;ACvLA;EACE,kBAAA;AD0LF;;ACvLA;EACE,kBAAA;AD0LF;;ACvLA;;;EAGE,kBAAA;EACA,qCAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AD0LF;;ACvLA;EACE,aAAA;AD0LF;;ACtLA;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;ADyLF;;ACtLA;EACE,kBAAA;ADyLF;;ACtLA;EACE,iBAAA;ADyLF;;ACtLA;EACE,gBAAA;ADyLF;;ACtLA;EACE,2BAAA;EACA,eAAA;EACA,WAAA;EACA,sCAAA;ADyLF;;ACtLA;;EAEE,aAAA;ADyLF;;ACrLA,UAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,8BAAA;EACA,oCAAA;ADwLF;;ACpLA;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kCAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,oDAAA;ADuLF;;ACpLA,qBAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;ADuLF;;ACpLA;EACE;IACE,UAAA;EDuLF;AACF;AAvgBE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,uBAAA;AAygBJ;;AA/fA;EACE,sBAAA;EACA,sCAAA;EACA,wBAAA;AAkgBF;;AA/fA;EACE,mCAAA;AAkgBF;;AA/fA;EACE,WAAA;EACA,iBAAA;AAkgBF;;AA/fA;EACE,oCAAA;AAkgBF;;AA9fA;EACE,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAigBF;;AA9fA;EACE,gBAAA;EACA,YAAA;EACA,oDAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAigBF;;AA9fA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,iCAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAigBF;;AA9fA;EACE,kBAAA;EACA,OAAA;EACA,OAAA;EACA,2BAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,0BAAA;EACA,YAAA;EACA,gCAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;EACA,gGAAA;EAEA,4CAAA;EACA,WAAA;AAggBF;AA9fE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;AAggBJ;AA7fE;EACE,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;AA+fJ;AA5fE;EACE,WAAA;EACA,4CAAA;EACA,4BAAA;AA8fJ;AA5fI;EACE,qCAAA;AA8fN;AA1fE;EACE,uCAAA;AA4fJ;AAzfE;EACE,SAAA;AA2fJ;AAzfI;EACE,yBAAA;AA2fN;AAxfI;EACE,WAAA;AA0fN;AAxfM;EACE,oDAAA;AA0fR;;AA/eA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;AAkfF;;AA/eA;EACE,wDAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;AAkfF;;AA/eA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAkfF;;AA/eA;EACE,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gCAAA;AAkfF;AAhfE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAkfJ;;AA9eA;EACE,wBAAA;EACA,8BAAA;EACA,yCAAA;EACA,QAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAifF;;AA9eA;EACE,0BAAA;AAifF;;AAzeA;;EAEE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kCAAA;AA4eF;AA1eE;;EACE,aAAA;EACA,uCAAA;AA6eJ;;AAzeA;EACE,0BAAA;EACA,0BAAA;EACA,4BAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,4BAAA;EACA,uBAAA;AA4eF;;AAxeE;EACE,iBAAA;EACA,aAAA;AA2eJ;AAzeI;EACE,sBAAA;AA2eN;AAxeI;EACE,gBAAA;AA0eN;AAveI;EACE,gBAAA;EACA,iCAAA;AAyeN;AAteI;EACE,QAAA;EACA,cAAA;AAweN;AAreI;EACE,QAAA;AAueN;AApeI;EACE,eAAA;AAseN;;AAjeA;EACE,mBAAA;EACA,WAAA;EACA,8DAAA;AAoeF;AAleE;EACE,gBAAA;EACA,qBAAA;AAoeJ;AAleI;EACE,mBAAA;AAoeN;AAjeI;EACE,6BAAA;AAmeN;AA/dE;EACE,iBAAA;EACA,oCAAA;AAieJ;;AA7dA;EACE,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,sBAAA;AAgeF;;AA7dA;EACE,kBAAA;AAgeF;AA9dE;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;AAgeJ;AA9dI;EACE,mBAAA;AAgeN;;AAtdA;EACE,gBAAA;EACA,iDAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,cAAA;EAYA,YAAA;AA8cF;AAxdE;EACE,YAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;AA0dJ;AAxdI;EACE,WAAA;AA0dN;;AApdA;EACE,gBAAA;EACA,iBAAA;AAudF;;AApdA;EACE,eAAA;EACA,cAAA;AAudF;AArdE;EACE,eAAA;AAudJ;AApdE;EACE,WAAA;AAsdJ;;AA9cA;EACE,kBAAA;EACA,wBAAA;AAidF;AA/cE;EACE,iBAAA;AAidJ;AA9cE;EACE,6BAAA;AAgdJ;AA7cE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;AA+cJ;AA7cI;EACE,4BAAA;EACA,yCAAA;EACA,2BAAA;AA+cN;AA5cI;EACE,gBAAA;AA8cN;AA3cI;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AA6cN;AA3cM;EACE,eAAA;AA6cR;AAzcI;EACE,OAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AA2cN;AAxcI;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,oEAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;AA0cN;AAxcM;EACE,YAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,wCAAA;AA0cR;AAxcQ;EACE,qBAAA;EACA,mBAAA;EACA,qBAAA;AA0cV;AAvcQ;EACE,qBAAA;AAycV;AApcI;EACE,UAAA;EACA,mBAAA;EACA,oBAAA;AAscN;;AAjcA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,QAAA;AAocF;AAlcE;EACE,cAAA;EACA,eAAA;AAocJ;;AAhcA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;AAmcF;;AAhcA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AAmcF;AAjcE;EACE,UAAA;AAmcJ;AAhcE;EACE,mBAAA;AAkcJ;AA/bE;EACE,mBAAA;EACA,kBAAA;AAicJ;AA/bI;EACE,mBAAA;AAicN;;AA5bA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA+bF;AA7bE;EACE,UAAA;AA+bJ;AA5bE;EACE,mBAAA;AA8bJ;AA3bE;EACE,mBAAA;EACA,kBAAA;AA6bJ;AA3bI;EACE,mBAAA;AA6bN;;AAxbA;EACE,gBAAA;AA2bF;;AAxbA;EACE,qBAAA;AA2bF;;AAxbA;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA2bF;;AAxbA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;AA2bF;AAzbE;EACE,mBAAA;AA2bJ;;AAvbA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;AA0bF;;AAvbA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,wCAAA;EACA,eAAA;AA0bF;AAxbE;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;AA0bJ;AAvbE;EACE,wBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;AAybJ;AAvbI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAybN;;AA/aA;EACE,gCAAA;EACA,2BAAA;EACA,kCAAA;EACA,6BAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAkbF;AAhbE;EACE,8BAAA;AAkbJ;AA/aE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAibJ;;AA7aA;EACE,qBAAA;EACA,iBAAA;EACA,2CAAA;EACA,6BAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAgbF;AA9aE;EACE,0CAAA;AAgbJ;;AA5aA;EACE,gCAAA;AA+aF;;AA5aA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iDAAA;EACA,mDAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AA+aF;AA7aE;EACE,0CAAA;AA+aJ;;AA3aA;EACE,6BAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,2CAAA;EACA,UAAA;AA8aF;;AAtaA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;AAyaF;AAvaE;EACE,mBAAA;EACA,yCAAA;AAyaJ;AAtaE;EACE,qBAAA;EACA,eAAA;EACA,cAAA;AAwaJ;;AApaA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAuaF;;AApaA;EACE,MAAA;EACA,QAAA;AAuaF;;AApaA;EACE,SAAA;EACA,QAAA;AAuaF;;AApaA;EACE,UAAA;EACA,QAAA;AAuaF;;AApaA;EACE,UAAA;EACA,QAAA;AAuaF;;AApaA;EACE,UAAA;EACA,QAAA;AAuaF;;AApaA;EACE,UAAA;EACA,QAAA;AAuaF;;AApaA;EACE,UAAA;EACA,QAAA;AAuaF;;AA/ZA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAkaF;;AA/ZA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAkaF;;AA/ZA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAkaF;;AA/ZA;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAkaF;;AA/ZA;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;AAkaF;;AA/ZA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAkaF;;AA1ZA;EACE,YAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;AA6ZF;;AA1ZA;EACE,2CAAA;AA6ZF;;AA1ZA;EACE,sBAAA;EACA,oDAAA;EACA,6BAAA;EACA,gBAAA;AA6ZF;;AA1ZA;EACE,oBAAA;EACA,sBAAA;AA6ZF;;AArZA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAwZF;;AArZA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAwZF;;AArZA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAwZF","sourcesContent":[".drawflow,\n.drawflow .parent-node {\n    position: relative\n}\n\n.parent-drawflow {\n    display: flex;\n    overflow: hidden;\n    touch-action: none;\n    outline: 0\n}\n\n.drawflow {\n    width: 100%;\n    height: 100%;\n    user-select: none\n}\n\n.drawflow .drawflow-node {\n    display: flex;\n    align-items: center;\n    position: absolute;\n    background: #0ff;\n    width: 160px;\n    min-height: 40px;\n    border-radius: 4px;\n    border: 2px solid #000;\n    color: #000;\n    z-index: 2;\n    padding: 15px\n}\n\n.drawflow .drawflow-node.selected {\n    background: red\n}\n\n.drawflow .drawflow-node:hover {\n    cursor: move\n}\n\n.drawflow .drawflow-node .inputs,\n.drawflow .drawflow-node .outputs {\n    width: 0\n}\n\n.drawflow .drawflow-node .drawflow_content_node {\n    width: 100%;\n    display: block\n}\n\n.drawflow .drawflow-node .input,\n.drawflow .drawflow-node .output {\n    position: relative;\n    width: 20px;\n    height: 20px;\n    background: #fff;\n    border-radius: 50%;\n    border: 2px solid #000;\n    cursor: crosshair;\n    z-index: 1;\n    margin-bottom: 5px\n}\n\n.drawflow .drawflow-node .input {\n    left: -27px;\n    top: 2px;\n    background: #ff0\n}\n\n.drawflow .drawflow-node .output {\n    right: -3px;\n    top: 2px\n}\n\n.drawflow svg {\n    z-index: 0;\n    position: absolute;\n    overflow: visible !important\n}\n\n.drawflow .connection {\n    position: absolute;\n    transform: translate(9999px, 9999px);\n    height: 200px;\n    padding-left: 6px;\n}\n\n@media (min-width:1200px) and (max-width:1300px) {\n    .drawflow .connection {\n        padding-left: 4px;\n    }\n  }\n\n  @media (min-width:1301px) and (max-width:1400px) {\n    .drawflow .connection {\n        padding-left: 4px;\n    }\n  }\n\n  @media (min-width:1401px) and (max-width:1600px) {\n    .drawflow .connection {\n        padding-left: 4px;\n    }\n  }\n\n  @media (min-width:1601px) and (max-width:1800px) {\n    .drawflow .connection {\n        padding-left: 4px;\n    }\n  }\n\n  @media (min-width:1801px) and (max-width:1920px) {\n    .drawflow .connection {\n        padding-left: 4px;\n    }\n  }\n\n  @media (min-width:1921px) and (max-width:2200px) {\n    .drawflow .connection {\n        padding-left: 12px;\n    }\n  }\n\n.drawflow .connection .main-path {\n    fill: none;\n    stroke-width: 5px;\n    stroke: #4682b4;\n    transform: translate(-9999px, -9999px)\n}\n\n.drawflow .connection .main-path:hover {\n    stroke: #1266ab;\n    cursor: pointer\n}\n\n.drawflow .connection .main-path.selected {\n    stroke: #43b993\n}\n\n.drawflow .connection .point {\n    cursor: move;\n    stroke: #000;\n    stroke-width: 2;\n    fill: #fff;\n    transform: translate(-9999px, -9999px)\n}\n\n.drawflow .connection .point.selected,\n.drawflow .connection .point:hover {\n    fill: #1266ab\n}\n\n.drawflow .main-path {\n    fill: none;\n    stroke-width: 5px;\n    stroke: #4682b4\n}\n\n.drawflow .selectbox {\n    z-index: 3;\n    position: absolute;\n    transform: translate(9999px, 9999px)\n}\n\n.drawflow .selectbox rect {\n    fill: #00f;\n    opacity: .5;\n    stroke: #ff0;\n    stroke-width: 5;\n    stroke-opacity: .5;\n    transform: translate(-9999px, -9999px)\n}\n\n.drawflow-delete {\n    position: absolute;\n    display: block;\n    width: 30px;\n    height: 30px;\n    background: #000;\n    color: #fff;\n    z-index: 4;\n    border: 2px solid #fff;\n    line-height: 30px;\n    font-weight: 700;\n    text-align: center;\n    border-radius: 50%;\n    font-family: monospace;\n    cursor: pointer\n}\n\n.drawflow>.drawflow-delete {\n    margin-left: -15px;\n    margin-top: 15px\n}\n\n.parent-node .drawflow-delete {\n    right: -15px;\n    top: -15px\n}","@use \"src/assets/css/drawflow.scss\" as *;\n@use \"src/assets/css/beautiful.scss\" as *;\n\n\n// ============================================\n// HOST & CONTAINER OVERRIDES\n// ============================================\n:host .custom-dialog-container {\n  .mat-mdc-dialog-container {\n    position: absolute;\n    height: 80%;\n    width: 80%;\n    padding: 0px !important;\n  }\n}\n\n\n// ============================================\n// LAYOUT COMPONENTS\n// ============================================\n\n// Main wrapper and workspace\n.wrapper-view {\n  width: 100% !important;\n  height: calc(100vh - 100px) !important;\n  display: flex !important;\n}\n\n.view-width {\n  width: calc(100vw - 35%) !important;\n}\n\n.workspace {\n  width: 100%;\n  padding-left: 0px;\n}\n\n.workspace-background {\n  background-color: #fafafa !important;\n}\n\n// Drawer components\n.drawer-container {\n  margin: 0;\n  border-radius: 0;\n  width: 100% !important;\n  height: 100%;\n  position: relative;\n}\n\nmat-drawer {\n  overflow: hidden;\n  height: 100%;\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15) !important;\n  width: 20% !important;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\nmat-drawer-content {\n  position: relative;\n  z-index: 1;\n  box-sizing: border-box;\n  overflow: hidden;\n  width: 100%;\n  background-color: none !important;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.drawer-toggle-tab {\n  position: absolute;\n  left: 0;\n  top: 9%;\n  transform: translateY(-50%);\n  height: 120px;\n  width: 48px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: var(--primary);\n  color: white;\n  border: 2px solid var(--primary);\n  border-left: none;\n  border-radius: 0 20px 20px 0;\n  cursor: pointer;\n  transition: left 400ms cubic-bezier(0.25, 0.8, 0.25, 1), \n              width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 12px 2px 16px rgba(0, 0, 0, 0.2);\n  z-index: 99;\n  \n  .tab-icon {\n    font-size: 28px;\n    width: 28px;\n    height: 28px;\n    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  \n  .tab-label {\n    writing-mode: vertical-rl;\n    text-orientation: mixed;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 1.5px;\n    text-transform: uppercase;\n    color: white;\n    user-select: none;\n  }\n  \n  &:hover {\n    width: 56px;\n    box-shadow: 12px 2px 16px rgba(0, 0, 0, 0.2);\n    border-color: var(--primary);\n    \n    .tab-icon {\n      transform: translateX(3px) scale(1.1);\n    }\n  }\n  \n  &:active {\n    transform: translateY(-50%) scale(0.97);\n  }\n  \n  &.drawer-open {\n    left: 20%;\n    \n    .tab-icon {\n      transform: rotate(180deg);\n    }\n    \n    &:hover {\n      width: 56px;\n      \n      .tab-icon {\n        transform: rotate(180deg) translateX(3px) scale(1.1);\n      }\n    }\n  }\n}\n\n\n// ============================================\n// HEADER SECTIONS\n// ============================================\n\n.flow-header {\n  margin: 0px;\n  padding: 0px;\n  background: white;\n  border-bottom: 1px solid #f0f0f0;\n  min-height: 60px;\n}\n\n.library-header {\n  background: linear-gradient(to bottom, #fafafa, #f5f5f5);\n  height: 48px;\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 1px solid #e0e0e0;\n  font-size: 14px;\n  position: relative;\n}\n\n.flow-library-label {\n  font-size: 14px; \n  color: #333;\n  height: 48px;\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n}\n\n.view-header {\n  height: auto !important;\n  border-radius: 0;\n  display: flex;\n  flex-wrap: nowrap;\n  padding: 12px 16px 12px 64px;\n  background: white;\n  border-bottom: 1px solid #f0f0f0;\n  \n  .col-4, .col-5 {\n    display: flex;\n    align-items: center;\n    font-size: 13px;\n    min-width: 0;\n  }\n}\n\n.blocks-header {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 8px;\n  padding: 12px 0;\n  width: 100% !important;\n  flex: 1 !important;\n  min-width: 0;\n}\n\n.expansion-header {\n  padding: 0 16px !important;\n}\n\n\n// ============================================\n// FORM ELEMENTS & INPUTS\n// ============================================\n\n.text-input,\n.select-input {\n  font-size: 13px;\n  margin-top: 8px;\n  padding-left: 8px;\n  color: #424242;\n  transition: border-color 0.2s ease;\n  \n  &:focus {\n    outline: none;\n    border-color: var(--primary) !important;\n  }\n}\n\n.text-input {\n  font-size: 13px !important;\n  margin-top: 8px !important;\n  padding-left: 8px !important;\n  height: 32px;\n  color: #424242 !important;\n  z-index: 1 !important;\n  background: white !important;\n  border: none !important;\n}\n\n.mat-mdc-form-field {\n  &.custom-edit-field {\n    font-size: 0.8rem;\n    padding: 10px;\n\n    .mat-mdc-form-field-wrapper {\n      padding-bottom: 1.25em;\n    }\n\n    input.mat-mdc-input-element {\n      padding: 2px 0px;\n    }\n\n    .mat-mdc-form-field-infix {\n      padding: 2px 0px;\n      border-top: 0em solid transparent;\n    }\n\n    .mat-mdc-form-field-label-wrapper {\n      top: 3px;\n      padding-top: 0;\n    }\n\n    .mat-mdc-form-field-label {\n      top: 0em;\n    }\n\n    .mat-mdc-form-field-subscript-wrapper {\n      margin-top: 3px;\n    }\n  }\n}\n\n.form-table {\n  margin-bottom: 16px;\n  width: 100%;\n  transition: margin-left 400ms cubic-bezier(0.25, 0.8, 0.25, 1);\n  \n  &.drawer-open {\n    margin-left: 20%;\n    width: 80% !important;\n\n    td {\n      white-space: nowrap;\n    }\n\n    td:first-child {\n      padding-left: 70px !important;\n    }\n  }\n  \n  tr {\n    line-height: 20px;\n    background-color: #ffffff !important;\n  }  \n}\n\ntable td {\n  color: #666 !important;\n  word-wrap: break-word;\n  font-size: 12px;\n  vertical-align: middle;\n}\n\n.flow-management-form {\n  padding-left: 10px;\n\n  .btn-form {\n    color: var(--primary);\n    background: #ffffff;\n    border-radius: 6px;\n    cursor: pointer;\n    z-index: 5;\n    margin-left: 10px;\n    transition: all 0.2s ease;\n    \n    &:hover {\n      background: #f5f5f5;\n    }\n  }\n}\n\n\n// ============================================\n// SEARCH COMPONENTS\n// ============================================\n\n.flow-search {\n  box-shadow: none;\n  border-bottom: 1px solid rgba(169, 169, 169, 0.3);\n  padding: 8px 12px;\n  background: #fafafa;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  flex-shrink: 0; // Prevent the search from being compressed\n  \n  input {\n    border: none;\n    background: transparent;\n    width: 100%;\n    font-size: 13px;\n    \n    &::placeholder {\n      color: #999;\n    }\n  }\n  height: 36px;\n}\n\n.flow-selection-area {\n  max-height: none;\n  overflow: visible;\n}\n\n.block-search {\n  padding: 0 12px;\n  margin: 12px 0;\n  \n  ::ng-deep .mat-mdc-input-element {\n    font-size: 13px;\n  }\n\n  ::ng-deep .mat-mdc-form-field {\n    width: 100%;\n  }\n}\n\n// ============================================\n// FLOW & BLOCK COMPONENTS\n// ============================================\n\n.flow-ui-wrapper {\n  margin-left: -1rem;\n  width: calc(100% + 1rem);\n\n  .drag-drawflow {\n    line-height: 24px;\n  }\n\n  .drawflow {\n    position: absolute !important;\n  }\n\n  .element-tile {\n    font-weight: 400;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    margin: 4px;\n    padding: 4px 6px;\n    font-size: 14px;\n    line-height: 24px;\n    background: white;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: grab;\n    position: relative;\n    \n    &:hover {\n      border-color: var(--primary);\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n      transform: translateY(-1px);\n    }\n    \n    &:active {\n      cursor: grabbing;\n    }\n    \n    > span:first-child {\n      flex-shrink: 0;\n      display: flex;\n      align-items: center;\n      z-index: 1;\n      \n      i {\n        font-size: 16px;\n      }\n    }\n    \n    > span:nth-child(2) {\n      flex: 1;\n      min-width: 0;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      padding-right: 0;\n    }\n\n    .element-options {\n      position: absolute;\n      right: 0;\n      top: 0;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      gap: 2px;\n      padding: 0 8px;\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.2s ease;\n      background: linear-gradient(to right, transparent, white 20%, white);\n      border-radius: 10px;\n      pointer-events: none;\n      z-index: 2;\n\n      button {\n        border: none;\n        background-color: white;\n        color: #666;\n        cursor: pointer;\n        padding: 4px 6px;\n        border-radius: 4px;\n        transition: all 0.2s ease;\n        font-size: 14px;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n        \n        &:hover {\n          color: var(--primary);\n          background: #f0f0ff;\n          transform: scale(1.1);\n        }\n\n        &.isShared {\n          color: var(--primary);\n        }\n      }\n    }\n    \n    &:hover .element-options {\n      opacity: 1;\n      visibility: visible;\n      pointer-events: auto; \n    }\n  }\n}\n\n.auto-cx-node {\n  display: flex;\n  align-items: center;\n  max-width: 300px;\n  padding: 2px 4px;\n  gap: 6px;\n  \n  i {\n    flex-shrink: 0;\n    font-size: 16px;\n  }\n}\n\n.block-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n  flex: 1;\n  font-size: 13px;\n}\n\n.blocks-display {\n  display: block;\n  position: relative;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 4px;\n  max-height: 48vh;\n  \n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 3px;\n    \n    &:hover {\n      background: #a8a8a8;\n    }\n  }\n}\n\n.expanded-blocks {\n  display: block;\n  position: relative;\n  max-height: 300px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  \n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 3px;\n    \n    &:hover {\n      background: #a8a8a8;\n    }\n  }\n}\n\n.default-blocks {\n  padding: 8px 4px;\n}\n\n.mat-expansion-panel-body {\n  padding: 0 !important;\n}\n\n.block-control {\n  padding: 8px 12px;\n  font-weight: 600;\n  font-size: 12px;\n  color: #444;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  background: #f8f8f8;\n  margin: 4px 8px 8px 8px;\n  border-radius: 4px;\n}\n\n.flow-option {\n  font-size: 13px;\n  line-height: 1em;\n  height: auto !important;\n  padding: 8px 12px;\n  display: block;\n  transition: background 0.2s ease;\n  \n  &:hover {\n    background: #f5f5f5;\n  }\n}\n\n.flow-type {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 8px 12px;\n  height: auto;\n  display: block;\n  color: var(--primary);\n  background: #f8f8f8;\n  margin: 4px 0;\n}\n\n.flow-auto-description {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  z-index: 9999;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  padding: 12px 16px;\n  color: #666;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  font-size: 13px;\n  \n  label {\n    font-weight: 600;\n    color: #444;\n    margin-right: 8px;\n  }\n\n  .flow-error {\n    display: flex !important;\n    align-items: center;\n    gap: 6px;\n    width: 100%;\n    padding: 8px 0 0 0;\n    color: var(--warning);\n    font-size: 12px;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n\n// ============================================\n// BUTTONS\n// ============================================\n\n.btn-header-icon {\n  color: var(--primary) !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  background-color: transparent;\n  border: 1px solid transparent;\n  margin: 0;\n  min-width: auto;\n  padding: 6px;\n  transform: translateY(10px) !important;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  \n  &:hover {\n    background: #f5f5f5 !important;\n  }\n  \n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.btn-navigate {\n  color: var(--primary);\n  background: white;\n  border: 1px solid var(--primary) !important;\n  border-radius: 6px !important;\n  cursor: pointer;\n  text-transform: uppercase;\n  float: right;\n  padding: 8px 16px;\n  font-size: 12px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  \n  &:hover {\n    background: rgba(var(--primary-rgb), 0.05);\n  }\n}\n\n.btn-workspace {\n  color: var(--primary) !important;\n}\n\n.add-custom {\n  color: var(--primary);\n  font-size: 10px;\n  font-weight: 600;\n  border: 1px solid var(--primary) !important;\n  padding: 0 8px !important;\n  margin-right: 8px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  --mdc-text-button-container-shape: 6px !important;\n  --mdc-text-button-container-height: 22px !important;\n  height: 22px !important;\n  white-space: nowrap;\n  flex: 0 0 auto;\n\n  &:hover {\n    background: rgba(var(--primary-rgb), 0.05);\n  }\n}\n\n.float-toggle {\n  position: relative !important;\n  bottom: 10px;\n  right: 0;\n  top: 25px;\n  height: 37px;\n  font-weight: 600;\n  font-size: 12px;\n  color: var(--primary);\n  border: 1px solid var(--primary) !important;\n  z-index: 5;\n}\n\n\n// ============================================\n// TOOL BUTTONS\n// ============================================\n\n.tool-btn {\n  position: absolute;\n  z-index: 10;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  \n  &:hover {\n    background: #f5f5f5;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  }\n  \n  em {\n    color: var(--primary);\n    font-size: 18px;\n    display: block;\n  }\n}\n\n.flow-toolbox {\n  position: absolute;\n  right: 16px;\n  top: 60px;\n}\n\n.btn-delete {\n  top: 0;\n  right: 0;\n}\n\n.btn-publish {\n  top: 56px;\n  right: 0;\n}\n\n.btn-clear {\n  top: 112px;\n  right: 0;\n}\n\n.btn-lock {\n  top: 168px;\n  right: 0;\n}\n\n.bar-zoom {\n  top: 224px;\n  right: 0;\n}\n\n.bar-in {\n  top: 280px;\n  right: 0;\n}\n\n.bar-out {\n  top: 336px;\n  right: 0;\n}\n\n\n// ============================================\n// LABELS & TEXT ELEMENTS\n// ============================================\n\n.control-label {\n  font-size: 14px;\n  color: #666;\n  margin-top: 12px;\n  font-weight: 500;\n}\n\n.element-type {\n  font-weight: 600;\n  font-size: 13px;\n  color: #444;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n  min-width: 0;\n  flex: 0 1 auto;\n  flex-shrink: 1;\n  margin-right: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.view-label {\n  padding-right: 8px;\n  font-weight: 600;\n  color: #666;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.view-header-label {\n  color: #333;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.description-label {\n  margin-top: 10px;\n  height: 20px;\n  line-height: 20px;\n  display: flex;\n  color: #666;\n}\n\n.truncate-label {\n  max-width: 70% !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 2px;\n  color: var(--text);\n}\n\n\n// ============================================\n// STATE & UTILITY CLASSES\n// ============================================\n\n.alert {\n  height: auto;\n  color: var(--warning);\n  font-size: 12px;\n  padding: 4px 0;\n}\n\n.border-bottom {\n  border-bottom: solid 1px #e0e0e0 !important;\n}\n\n.panel-elevation {\n  margin: 8px !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n  border-radius: 8px !important;\n  overflow: hidden;\n}\n\n.viewMode-position {\n  top: 16px !important;\n  right: 16px !important;\n}\n\n\n// ============================================\n// EMPTY STATES\n// ============================================\n\n.no-result {\n  padding: 16px;\n  color: #999;\n  text-align: center;\n  font-size: 13px;\n}\n\n.no-blocks-found {\n  padding: 20px;\n  color: #999;\n  text-align: center;\n  font-size: 13px;\n}\n\n.empty-grid {\n  padding: 40px 20px;\n  text-align: center;\n  color: #999;\n  font-size: 13px;\n}\n",":root {\n  --border-color: #cacaca;\n  --background-color: #ffffff;\n\n  --background-box-title: #f7f7f7;\n}\n\nhtml,\nbody {\n  margin: 0px;\n  padding: 0px;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  font-family: 'Lato', sans-serif;\n}\n\nheader {\n  height: 66px;\n  border-bottom: 1px solid var(--border-color);\n  padding-left: 20px;\n}\n\nheader h2 {\n  margin: 0px;\n  line-height: 66px;\n}\n\nheader a {\n  color: black;\n}\n\n.them-edit-link {\n  position: absolute;\n  top: 10px;\n  right: 100px;\n  color: black;\n  font-size: 40px;\n}\n\n.them-edit-link a {\n  text-decoration: none;\n}\n\n.github-link {\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  color: black;\n}\n\n.wrapper {\n  width: 100%;\n  height: calc(100vh - 67px);\n  display: flex;\n}\n\n.col {\n  overflow: auto;\n  width: 300px;\n  height: 100%;\n  border-right: 1px solid var(--border-color);\n}\n\n.drag-drawflow {\n  line-height: 50px;\n  border-bottom: 1px solid var(--border-color);\n  padding-left: 5px;\n  cursor: move;\n  user-select: none;\n}\n\n.menu {\n  position: absolute;\n  height: 40px;\n  display: block;\n  background: white;\n  width: 100%;\n}\n\n.menu ul {\n  padding: 0px;\n  margin: 0px;\n  line-height: 40px;\n}\n\n.menu ul li {\n  display: inline-block;\n  margin-left: 10px;\n  border-right: 1px solid var(--border-color);\n  padding-right: 10px;\n  line-height: 40px;\n  cursor: pointer;\n}\n\n.menu ul li.selected {\n  font-weight: bold;\n}\n\n.swal-wide {\n  width: 80% !important;\n}\n\n.bar-zoom svg {\n  cursor: pointer;\n  padding-left: 10px;\n}\n\n.bar-zoom svg:nth-child(1) {\n  padding-left: 0px;\n}\n\n#drawflow {\n  position: relative;\n  width: calc(100vw - 40px);\n  height: calc(100% - 80px);\n  background: var(--background-color);\n  background-size: 25px 25px;\n  background-image:\n    linear-gradient(to right, #f1f1f1 1px, transparent 1px),\n    linear-gradient(to bottom, #f1f1f1 1px, transparent 1px);\n}\n\n@media only screen and (max-width: 768px) {\n  .col {\n    width: 50px;\n  }\n\n  .col .drag-drawflow span {\n    display: none;\n  }\n\n  #drawflow {\n    width: calc(100vw - 51px);\n  }\n}\n\n/* Editing Drawflow */\n\n.drawflow .drawflow-node {\n  background: var(--background-color);\n  border: 1px solid var(--border-color);\n  -webkit-box-shadow: 0 2px 15px 2px var(--border-color);\n  box-shadow: 0 2px 15px 2px var(--border-color);\n  padding: 0px;\n  width: 200px;\n}\n\n.drawflow .drawflow-node.selected {\n  background: white;\n  border: 1px solid #4ea9ff;\n  -webkit-box-shadow: 0 2px 20px 2px #4ea9ff;\n  box-shadow: 0 2px 20px 2px #4ea9ff;\n}\n\n.drawflow .drawflow-node.selected .auto-cx-node {\n  color: #22598c;\n}\n\n.drawflow .connection .main-path {\n  stroke: #4ea9ff;\n  stroke-width: 3px;\n}\n\n.drawflow .drawflow-node .input,\n.drawflow .drawflow-node .output {\n  height: 15px;\n  width: 15px;\n  border: 2px solid var(--border-color);\n}\n\n.drawflow .drawflow-node .input:hover,\n.drawflow .drawflow-node .output:hover {\n  background: #4ea9ff;\n}\n\n.drawflow .drawflow-node .output {\n  right: 10px;\n}\n\n.drawflow .drawflow-node .input {\n  left: -10px;\n  background: white;\n}\n\n.drawflow>.drawflow-delete {\n  border: 2px solid #43b993;\n  background: white;\n  color: #43b993;\n  -webkit-box-shadow: 0 2px 20px 2px #43b993;\n  box-shadow: 0 2px 20px 2px #43b993;\n}\n\n.drawflow-delete {\n  border: 2px solid #4ea9ff;\n  background: white;\n  color: #4ea9ff;\n  -webkit-box-shadow: 0 2px 20px 2px #4ea9ff;\n  box-shadow: 0 2px 20px 2px #4ea9ff;\n}\n\n.drawflow-node .auto-cx-node {\n  input {\n    background: transparent;\n    border: none;\n    font-family: Lato;\n  }\n\n  height: 50px;\n  line-height: 50px;\n  background: var(--background-box-title);\n  border-bottom: 1px solid #e9e9e9;\n  border-radius: 4px 4px 0px 0px;\n  padding-left: 10px;\n}\n\n.drawflow .auto-cx-node svg {\n  position: initial;\n}\n\n.drawflow-node .box {\n  padding: 10px 20px 20px 20px;\n  font-size: 14px;\n  color: #555555;\n\n}\n\n.drawflow-node .box p {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.drawflow-node.welcome {\n  width: 250px;\n}\n\n.drawflow-node.slack .auto-cx-node {\n  border-radius: 4px;\n}\n\n.drawflow-node.primitive .auto-cx-node {\n  border-radius: 4px;\n}\n\n.drawflow-node.composite .auto-cx-node {\n  border-radius: 4px;\n}\n\n.drawflow-node.operator .auto-cx-node {\n  border-radius: 4px;\n}\n\n.drawflow-node.logic .auto-cx-node {\n  border-radius: 4px;\n}\n\n.drawflow-node input,\n.drawflow-node select,\n.drawflow-node textarea {\n  border-radius: 4px;\n  border: 1px solid var(--border-color);\n  height: 30px;\n  line-height: 30px;\n  font-size: 16px;\n  width: 158px;\n  color: #555555;\n}\n\n.drawflow-node textarea {\n  height: 100px;\n}\n\n\n.drawflow-node.personalized {\n  background: red;\n  height: 200px;\n  text-align: center;\n  color: white;\n}\n\n.drawflow-node.personalized .input {\n  background: yellow;\n}\n\n.drawflow-node.personalized .output {\n  background: green;\n}\n\n.drawflow-node.personalized.selected {\n  background: blue;\n}\n\n.drawflow .connection .point {\n  stroke: var(--border-color);\n  stroke-width: 2;\n  fill: white;\n  transform: translate(-9999px, -9999px);\n}\n\n.drawflow .connection .point.selected,\n.drawflow .connection .point:hover {\n  fill: #4ea9ff;\n}\n\n\n/* Modal */\n.modal {\n  display: none;\n  position: fixed;\n  z-index: 7;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: auto;\n  background-color: rgb(0, 0, 0);\n  background-color: rgba(0, 0, 0, 0.7);\n\n}\n\n.modal-content {\n  position: relative;\n  background-color: #fefefe;\n  margin: 15% auto;\n  /* 15% from the top and centered */\n  padding: 20px;\n  border: 1px solid #888;\n  width: 400px;\n  /* Could be more or less, depending on screen size */\n}\n\n/* The Close Button */\n.modal .close {\n  color: #aaa;\n  float: right;\n  font-family: Lato;\n  font-size: 28px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n@media only screen and (max-width: 768px) {\n  .modal-content {\n    width: 80%;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
